module.exports = __webpack_public_path__ + "static/media/track.67518909.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Audio/track.mp3
// module id = 523
// module chunks = 0